import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, Alert } from "shards-react";
import { Menu, Item, contextMenu } from "react-contexify";
import { GetCourseList,getPlan,getBranding } from "../services/api";
import { getCourseDetails, deleteCourse } from "../services/api";
import "react-contexify/dist/ReactContexify.css";
import PageTitle from "../components/common/PageTitle";
import axios from "axios";
import { Store } from "../flux";
import IconDisplay from "../components/common/IconDisplay";
import Load from "../Load";
import BreadCrumb from "../components/common/BreadCrumb";
import { Dispatcher, Constants } from "../flux";
import { FloatingButton, Item as FItem } from "react-floating-button";
import Joyride from 'react-joyride';
import { FaTimesCircle } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import { FiBookOpen } from "react-icons/fi";
import EditCourse from "./EditCourse";
import AddCourse from "./AddCourse";

const steps =  [
  {
    content: (
      <div>
        You can interact with your own components through the spotlight.
        <br />
        Click the menu above!
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: false,
    hideCloseButton: true,
    // hideFooter: true,
    placement: 'bottom',
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    target: '.step-logo',
    title: 'Menu',
  },
  {
    content: (
      <div>
        You can interact with your own components through the spotlight.
        <br />
        Click the menu above!
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: false,
    hideCloseButton: true,
    // hideFooter: true,
    placement: 'right',
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    target: '.step-home',
    title: 'Menu',
  },
  {
    content: (
      <div>
        You can interact with your own components through the spotlight.
        <br />
        Click the menu above!
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: false,
    hideCloseButton: true,
    // hideFooter: true,
    placement: 'right',
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    target: '.step-tasks',
    title: 'Menu',
  },
  {
    content: (
      <div>
        You can interact with your own components through the spotlight.
        <br />
        Click the menu above!
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: false,
    hideCloseButton: true,
    // hideFooter: true,
    placement: 'right',
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    target: '.step-video-library',
    title: 'Menu',
  },
  {
    content: (
      <div>
        You can interact with your own components through the spotlight.
        <br />
        Click the menu above!
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: false,
    hideCloseButton: true,
    // hideFooter: true,
    placement: 'right',
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    target: '.step-library',
    title: 'Menu',
  },
  {
    content: (
      <div>
        You can interact with your own components through the spotlight.
        <br />
        Click the menu above!
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: false,
    hideCloseButton: true,
    // hideFooter: true,
    placement: 'right',
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    target: '.step-planner',
    title: 'Menu',
  }
];



class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { editMode: false, posts: [],loading:false, isTourOpen: true, stepIndex: 0, run: true, tour: Store.getTour(), currentUser : Store.getCurrentUser(),  selectedUser: null, edit: false, originalCopy: [] };
    let currentUser = Store.getCurrentUser();
    let id = currentUser.Institution;
    getBranding(id).then((data)=>{
      Dispatcher.dispatch({
        actionType: Constants.BRAND,
        payload: data
      });
      })
      this.goBack = this.goBack.bind(this);
  }
  componentDidMount() {
    // this.setState({...this.state,loading:false});
    let currentUser = Store.getCurrentUser();
    GetCourseList(currentUser).then(res => {
      this.setState({ ...this.state, posts: res,loading:false });
    }).catch(()=>{
      this.setState({...this.state,loading:false});
    });

    getPlan(currentUser.Institution,currentUser).then((data)=>{
      Dispatcher.dispatch({
        actionType: Constants.PLAN,
        payload: data
      });
    }).catch(()=>{});
  
  }

  handleOpenModal(type){
    if(type=='edit'){
      this.setState({...this.state, editMode: !this.state.editMode});
    } else {
      this.setState({...this.state, add: true})
    }

  }
  goBack() {
    // this.setState({...this.state,loading:false});
    GetCourseList(this.state.currentUser).then(res => {
      this.setState({ ...this.state, posts: res,loading:false, editMode: false, edit: false, add: false });
    }).catch(()=>{
      this.setState({...this.state,loading:false});
    });
    }
  manageClick(name, id) {
    var result = this.state.posts.filter(obj => {
      return obj.id === id;
    });
    if (name == "Edit") {
      this.setState({ ...this.state, edit: true, selectedUser: result[0] });
    } else {
      let data = {
        ShortCode: result[0].ShortCode,
        Institution: result[0].School
      };
      deleteCourse(data, this.state.currentUser).then(data => {
        this.goBack();
      }).catch(()=>{});
    }
  }
  addCourse() {
    this.setState({ ...this.state, add: true });
  }

  render() {
    var stage = (this.state.tour== null ? 'initial' : this.state.tour.stage);
    var isStage = stage == 'home';
    return this.state.loading ? (
      <Container style={{height: window.innerHeight-80}} fluid className="main-content-container px-4">
        <Load />
      </Container>
    ) : this.state.add ? (
      <AddCourse
        type={`STUDENT`}
        nav={this.goBack}
        user={this.state.selectedUser}
      ></AddCourse>
    ) : this.state.edit ? (
      <EditCourse
        type={`Student`}
        nav={this.goBack}
        course={this.state.selectedUser}
      ></EditCourse>
    ) : (
      <div>
      {/* <Alert className="mb-0 alert-warning">
      <span id="tour" onClick = {()=>{
        Dispatcher.dispatch({
          actionType: Constants.TOUR,
          payload: {run: true, stage: 'home'}
        });
        window.location.reload();
      }}><i className="fa fa-info mx-2"></i> Feeling stuck? Take a guided Tour! &nbsp;<span style={{color: 'blue'}}>Click Here</span></span>
    </Alert> */}
      <Container fluid style={{height: window.innerHeight-80}} className="main-content-container px-4">
          
        <Row noGutters className="page-header py-4">
          <BreadCrumb />
        </Row>
        {this.state.currentUser.Type != "STUDENT" ? (
          <FloatingButton id={'floatHome'}>
            <FItem
              backgroundColor={`#FFFFFF`}
              imgSrc={`data:image/png;base64,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`}
              onClick={()=>{this.handleOpenModal('edit')}}
            />
             <FItem
              backgroundColor={`#FFFFFF`}
              imgSrc={`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAMFBMVEX///8AAAAgICAXFxcEBAR2dnYdHR0iIiL7+/t+fn4REREaGhp7e3sYGBghISGAgICNvUoRAAABXElEQVR4nO3bXWrDMBCF0ciN7fy12f9uSzdQiYypbsM5zwLNB34b+XQCAAAAAAD4cV17HrNHLLq3ntvsEYuWbuHH7BGLFCrMp1BhPoUK8ylUmE+hwnwKFeZTqDCfQoX5FCrMp1BhPoUK8ylUmE+hwnwKFeZTqDCfQoX5FCrMp1BhPoUK8ylUmE+hwnxvX3jZ2/l37X6ZN951W6r2fevZl+6Rns/ri4Vr9wvr2w440bfOKzwPFJ7r1yhUWKCwKRyjUGGBwqZwjEKFBQqbwjEKFRYobArHKFRYoLApHKNQYYHCpnDMxMLw/eHf7IC/9vIt2/PFwgOE7/GP8PZvMRQq/AcUKsynUGE+hQrzKVSYT6HCfAoV5lOoMJ9ChfkUKsynUGE+hQrzKVSYT6HCfAoV5lOoMJ9ChfkUKsynUGE+hQrzKVSY7/0L+3/53maPWPRcex6zRwQAAAAAAEJ8AyUFNKCVM/GGAAAAAElFTkSuQmCC`}
              onClick={()=>{this.handleOpenModal('add')}}
            />
            
            
          </FloatingButton>
        ) : (
          ""
        )}
        <Row>
          {this.state.posts.map((post, idx) => (
            <Col
              lg="3"
              md="6"
              id={idx}
              onClick={() => {
                if(!this.state.editMode)
                this.props.history.push(`/course/${post.ShortCode}`);
              }}
              sm="12"
              className="mb-4"
              key={idx}
            >
              <Card small className="card-post card-post--1">
                
                <div
                  className="card-post__image"
                  style={{ backgroundImage: `url(${post.Image})` }}
                >{this.state.editMode?<FaTimesCircle onClick={(()=>{this.manageClick('Delete',post.id)})} color={'red'} class={'rightClose'}/>:''}</div>
                <CardBody>
                  <h5 className="card-title">
                    <a href="#" className="text-fiord-blue">
                      {post.Name} {this.state.editMode?<FaPencilAlt color={'#FFBF00'} onClick={()=>{this.manageClick('Edit',post.id)}} style={{marginLeft:'10px'}}/> : ''}
                    </a>
                  </h5>
                  <p className="card-text d-inline-block mb-3"></p>
                  <span className="text-muted"></span>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        {/* <Joyride
          continuous={true}
          run={isStage}
          steps={steps}
          stepIndex={this.state.stepIndex}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          callback={(x)=>{
            if(x.action == 'next' && x.lifecycle == 'complete'){
              if(x.index == 0){
                Dispatcher.dispatch({
                  actionType: Constants.TOGGLE_SIDEBAR
                });
                setTimeout(()=>{
                  this.setState({...this.state, stepIndex: x.index+1})
                }, 100);
              } else if (x.index == 5){
                Dispatcher.dispatch({
                  actionType: Constants.TOGGLE_SIDEBAR
                });
                Dispatcher.dispatch({
                  actionType: Constants.TOUR,
                  payload: {run: true, stage: 'actions'}
                });
                this.setState({...this.state, stepIndex: x.index+1});
                window.location.reload(0,0);
              } else {
              this.setState({...this.state, stepIndex: x.index+1})
              }
            }
            if(x.action == 'close'){
              Dispatcher.dispatch({
                actionType: Constants.TOUR,
                payload: {run: false, stage: 'initial'}
              });
            }
          //  this.setState({...this.state, stepIndex: this.state.stepIndex+1})
          }}
        /> */}
      </Container>
      </div>
    );
  }
}

export default Home;
